interface ClaimedIndicatorProps {
  className?: string;
}

export function ClaimedIndicator({ className = '' }: ClaimedIndicatorProps) {
  return (
    <div className={`claimed-blink font-bold text-lg ${className}`} style={{ color: '#991b1b' }}>
      Claimed
    </div>
  );
}
